export enum DeeplinkKeys {
  projectId = 'projectId',
  presetJsonUrl = 'presetJsonUrl',
  presetId = 'presetId',
  category = 'genaicategory',
  taskId = 'task_id',
  hideBackButton = 'hideBackButton',
  socialShareState = 'state',
}
